export { ClientRightsPage as default } from "@nvb/ui";
